import { createContext } from 'react';

/** @type {Context<{ show: ModalShow, state: ModalState, hide: ModalHide, remove: ModalRemove, clear: ModalClear }>} */
export const ModalContext = createContext({
  show: () => null,
});
